function Project({ title, image, description, features, previewLink }) {
  return (
    <article className="
      w-full rounded-2xl overflow-hidden
      border border-slate-200 dark:border-slate-700
      shadow-xl dark:shadow-slate-900/60
      hover:shadow-2xl transition-shadow duration-300
      bg-white dark:bg-dark-card
      flex flex-col
    ">
      {/* Image + Details row */}
      <div className="flex flex-col md:flex-row flex-1">

        {/* Image panel */}
        <div className="
          w-full md:w-2/5 md:flex-shrink-0 md:min-h-[420px]
          bg-slate-50 dark:bg-slate-800
          flex items-center justify-center
          p-6 md:p-8
          overflow-hidden group
        ">
          <img
            src={image}
            alt={title}
            loading="lazy"
            className="
              w-full h-auto max-h-[300px] md:max-h-[360px]
              object-contain
              transition-transform duration-700 ease-in-out
              group-hover:scale-105
            "
          />
        </div>

        {/* Details panel */}
        <div className="flex-1 min-w-0 flex flex-col justify-between px-8 py-8 md:px-10 lg:px-12">

          {/* Top: title + description + features */}
          <div>
            <h2 className="text-xl md:text-2xl lg:text-3xl font-bold text-gradient leading-snug mb-4">
              {title}
            </h2>
            <p className="text-content text-sm md:text-base font-medium leading-relaxed max-w-lg">
              {description}
            </p>
            <ul className="mt-5 space-y-2 max-w-lg">
              {features.map((feature, i) => (
                <li key={i} className="flex gap-3 text-sm text-content leading-snug">
                  <span className="text-sky-500 font-bold flex-shrink-0 mt-0.5">—</span>
                  <span className="font-medium">{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Bottom: button pinned to bottom */}
          <div className="mt-8 pt-6 border-t border-slate-100 dark:border-slate-700">
            {previewLink ? (
              <a
                href={previewLink}
                target="_blank"
                rel="noreferrer noopener"
                className="inline-flex items-center gap-2 text-sm font-semibold
                           px-5 py-2.5 rounded-full
                           bg-gradient-to-r from-sky-500 to-purple-500
                           text-white hover:opacity-90 transition-opacity"
              >
                View Live Site
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" strokeWidth="2.5"
                     strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </a>
            ) : (
              <span className="inline-flex items-center gap-2 text-sm text-content
                               italic px-4 py-2 rounded-full
                               border border-slate-200 dark:border-slate-700">
                Internal project — no public demo
              </span>
            )}
          </div>

        </div>
      </div>
    </article>
  );
}

export default Project;
